/* unplugin-vue-components disabled */import script from "./level_copy.vue?vue&type=script&setup=true&lang=js"
export * from "./level_copy.vue?vue&type=script&setup=true&lang=js"

import "./level_copy.vue?vue&type=style&index=0&id=6b488734&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b488734"]])

export default __exports__